<div class="col-md-12">
  <span class="section-header">Price Lookup</span>
  <div class="row-no-margin" [hidden]="!HideLookup">
    <button (click)="LookupAnotherItem()" class="blue">LOOKUP ANOTHER ITEM</button>
  </div>
  <div [hidden]="HideLookup">
    <div class="section-header-container">
      <div class="col-md-6 clear-padding">
        <mat-form-field *ngIf="CurrentUser.IsTolomaticUser" appearance="fill">
          <mat-label>Distributor:</mat-label>
          <mat-select id="orderDistributor" (selectionChange)="Dist_Change($event)" [(value)]="CurrentDist.CompanyId">
            <mat-option *ngFor="let dist of DistList" [value]="dist.CompanyId">
              {{dist.Company}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6 clear-padding">

      </div>
    </div>

    <div class="pricing-section">
      <span class="darkblue-label">ENTER AN 8 DIGIT ITEM OR CONFIGURED STRING</span>

      <br />
      <input placeholder="########" [(ngModel)]="ConfigString" (keyup.enter)="PriceItem(ConfigString)" style="width:40%;" type="text" class="with-button" />
      <fa-icon [icon]="faSearch" (click)="SearchForItem()" style="padding-right:15px;margin-left:-31px;" class="clickable blue-color"></fa-icon>
      <button (click)="PriceItem(ConfigString)" class="with-input blue">PRICE</button>
      <br />
      <span [hidden]="!InvalidItem" class="red">Invalid Item Number/Incomplete Config String</span>
    </div>
    <!--<div class="pricing-section">
      <span class="darkblue-label">QUANTITY</span>
      <br />
      <input placeholder="0" [(ngModel)]="Quantity" type="number" min="0" />
    </div>-->
    <div class="pricing-section">
      <span class="darkblue-label">DETAILED ITEM PRICING</span>
      <br />
      <button (click)="CreateNewConfig(null)" class="blue">BUILD ITEM</button>
    </div>
  </div>
  <br />
  <div [hidden]="ItemList.length == 0" class="row-no-margin">
    <app-price-break [ItemPriceList]="ItemList" [Customer]="CurrentDist" [OverridePricingRule]="OverrideBreakPricingRule" style="width:100%;"></app-price-break>
  </div>
  <div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:inherit;float:left;position:absolute;z-index:10000;display:block;left:0;top:0px;bottom:0px; background-color:#AAAAAA;opacity:0.4;">
    <div style="position: absolute; top: 45%; left: 45%;">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  </div>
</div>
